export const range = (start: number, end: number): Array<number> => {
  return [...Array(end + 1).keys()].slice(start)
}
